const state = {
  statusMenu: false,
  itemMenu: {},
  subItemMenu: {}
}

const mutations = {
  setItemMenu (state, value) {
    state.itemMenu = value
  },
  setSubItemMenu (state, value) {
    state.subItemMenu = value
  },
  setStatusMenu (state, value = null) {
    if (value) {
      state.statusMenu = value
    } else {
      state.statusMenu = !state.statusMenu
    }
  }
}

const actions = {
}

export default { namespaced: true, state, mutations, actions }
